/**
 * Convert a class string to a class map that can be used with lit's classMap.
 * @param classString - The class string to convert. Example: 'class1 class2'
 * @returns The class map. Example: { class1: true, class2: true }
 */
export function convertClassStringToProps(classString: string): Record<string, boolean> | null {
  if (classString === '') {
    return null;
  }
  const props = classString
    .trim()
    .split(' ')
    .filter((className) => className !== '')
    .reduce((acc: Record<string, boolean>, className: string) => {
      acc[className] = true;
      return acc;
    }, {});
  return props;
}
